import UserEntity from "../2_Entities/UserEntity";
import IUserRepository from "../4_Repositories/IUserRepository";
import { userEntity } from "../2_Entities/factory";
import { IStorage } from "../../_shared/Storage/IStorage";
import FetcherInput, { TypeRole } from "../../_shared/Fetcher/FetcherInput";
import Keycloak from "keycloak-js";
import { v5 as uuidv5 } from "uuid";
import Config from "domain/_config/";
import { ROLE_CANDIDATE, ROLE_CANDIDATE_EPG, URL_DOMAIN_EPG, URL_DOMAIN_PREG } from "utils/ConstantsAndNum";

enum roleException {
  default = "default-roles-xpedition",
  offline = "offline_access",
  administrative = "administrative",
  uma = "uma_authorization",
  studentclass = "studentclass",
  teacherclass = "teacherclass",
}

export default class UserRepository implements IUserRepository {
  private static _UserEntity: UserEntity | null;
  private static _usersEntities: Map<string, UserEntity>;
  public static readonly TOKEN_STORAGE = "_%0363f2y&U^EÃ‡w8>N";
  public static readonly REFRESH_TOKEN_STORAGE = "gWz8s6$*9d";
  public static readonly ROLE_STORAGE = "#Ye019!!PEN05z";
  private static readonly ROLE_STORAGE_TEST = "#!!TTDW05452q";
  public static readonly ROLE_STORAGE_ACTIVE = "#roleactive";
  private static readonly USERID_STORAGE = "#Ye019!!PEN0asd5z";
  private static readonly ID_USER_ACTIVE = "#idactive";
  private static readonly ACTIVE_COURSE = "#activecourse";
  private static readonly ACTIVE_SECTION = "#activesection";
  private static readonly USER_TEACHER_VIEWER = "#teacherviewer";
  private static KEYCLOAK: Keycloak;
  private static AUTHENTICATED: boolean;
  private readonly _storage: IStorage;
  private readonly _fetcher: FetcherInput;

  private isDomainEPG(): boolean {
    return [URL_DOMAIN_EPG].includes(window.location.hostname);
  }

  private isDomainPREG(): boolean {
    return [URL_DOMAIN_PREG].includes(window.location.hostname);
  }

  private cleanRoleList(list: string[]): any {
    const isEPGDomain = this.isDomainEPG();
    const isPREGDomain = this.isDomainPREG();

    if (isEPGDomain && list.includes(ROLE_CANDIDATE_EPG)) {
      return [ROLE_CANDIDATE_EPG];
    }
    
    if (isPREGDomain && list.includes(ROLE_CANDIDATE)) {
      return [ROLE_CANDIDATE];
    }

    if (list.includes(ROLE_CANDIDATE_EPG)) return [ROLE_CANDIDATE_EPG];
    
    if (list.includes(ROLE_CANDIDATE)) return [ROLE_CANDIDATE];
    
    const listTemp = list.filter(
      (item: string) =>
        item !== roleException.default &&
        item !== roleException.offline &&
        item !== roleException.administrative &&
        item !== roleException.uma
    );

    return [...new Set(listTemp)];
  }

  private cleanNewRoles(role: TypeRole): TypeRole {
    if (role === "STUDENTCLASS") {
      return "STUDENT";
    }

    return role;
  }

  constructor(storage: IStorage, fetcher: FetcherInput) {
    this._storage = storage;
    this._fetcher = fetcher;
    const config = new Config();
    const keycloakConfig = config.get("KEYCLOAK_CONFIG");
    UserRepository._usersEntities = new Map<string, UserEntity>();
    UserRepository.KEYCLOAK = new Keycloak(keycloakConfig);
  }

  private async fetchUserEntity() {
    const keycloak: Keycloak = UserRepository.KEYCLOAK;
    const tokenParsed: any = keycloak?.tokenParsed;
    const token = this._storage.getItem(UserRepository.TOKEN_STORAGE) as string;
    const refreshToken = this._storage.getItem(
      UserRepository.REFRESH_TOKEN_STORAGE
    ) as string;
    const role = this._storage.getItem(UserRepository.ROLE_STORAGE_ACTIVE);
    const roleUppercase = role?.toLocaleUpperCase() as TypeRole;
    const userId = this._storage.getItem(
      UserRepository.USERID_STORAGE
    ) as string;

    const idUserSupport: string | null = window.localStorage.getItem(
      UserRepository.ID_USER_ACTIVE
    );

    this._fetcher.updateAuthorization(
      token,
      refreshToken,
      userId,
      roleUppercase,
      idUserSupport
    );

    const idTempStudent: string | null = window.localStorage.getItem(
      UserRepository.ID_USER_ACTIVE
    );

    let entity;

    if (roleUppercase) {
      /*
       * Esta validación sirve para verificar si un usuario real o un usuario temporal
       */
      if (idTempStudent && idTempStudent.length > 0) {
        entity = userEntity({
          id: idTempStudent,
          code: "",
          firstName: "",
          lastName: "",
          document: {
            type: "",
            number: "",
          },
          role: "STUDENT",
          properties: null,
        });
      } else {
        /*
         * Se aplica un valor por defecto para los cambpos
         * lastName y firstName en caso keylock no lo devuelva
         */

        const lastName: string = tokenParsed.family_name
          ? tokenParsed.family_name
          : "User";
        const firstName: string = tokenParsed.given_name
          ? tokenParsed.given_name
          : "User";

        const dataGenerateKeycloak: any = {
          userId: "f59c2d2e-3f82-5498-987e-297d63da8d9e",
          code: tokenParsed["preferred_username"],
          documentType: "DNI",
          documentNumber: "00000000",
          firstName: firstName,
          lastName: lastName,
          period: null,
          birthdate: null,
          userRoleName: tokenParsed.roles[0],
          roleStatus: "ACTIVE",
        };
        entity = userEntity({
          ...dataGenerateKeycloak,
          id: userId,
          document: {
            type: "",
            number: "",
          },
          role: this.cleanNewRoles(roleUppercase),
          properties: null,
        });
      }
    }

    UserRepository._usersEntities.set(userId, entity as any);
    UserRepository._UserEntity = entity as any;
    return UserRepository._UserEntity;
  }

  private hasSession() {
    const token = this._storage.getItem(UserRepository.TOKEN_STORAGE);
    const refreshToken = this._storage.getItem(
      UserRepository.REFRESH_TOKEN_STORAGE
    );
    const role = this._storage.getItem(UserRepository.ROLE_STORAGE);
    return !!(token && refreshToken && role);
  }

  public async current() {
    if (!this.hasSession()) return null;
    if (UserRepository._UserEntity) return UserRepository._UserEntity;
    return this.fetchUserEntity();
  }

  /*
   * setUserSupportIdActive
   * @param {string} role
   * esta función se encarga de guardar el rol cuando se muestra la pantalla de elegir roles
   */
  public async setUserRoleActive(role: string) {
    this._storage.setItem(UserRepository.ROLE_STORAGE_ACTIVE, role);
    return this.fetchUserEntity();
  }

  public async cleanUserSupportIdActive() {
    localStorage.setItem(UserRepository.ID_USER_ACTIVE, "");
    localStorage.setItem(UserRepository.ACTIVE_COURSE, "");
    localStorage.setItem(UserRepository.USER_TEACHER_VIEWER, "");
    localStorage.setItem(UserRepository.ACTIVE_SECTION, "");
    return true;
  }

  /*
   * Esta función se encarga de borrar el rol activo
   */
  public async cleanUserRoleActive(): Promise<boolean> {
    this._storage.setItem(UserRepository.ROLE_STORAGE_ACTIVE, "");
    return true;
  }

  public clearAccess() {
    this._storage.clear();
    UserRepository._UserEntity = null;
  }

  public async getById(userId: string) {
    const {
      data: { data: userData },
    } = await this._fetcher.request.get(`/user/users/${userId}`);

    const entity = userEntity({
      ...userData,
      id: userData.userId,
      document: {
        type: userData.documentType,
        number: userData.documentNumber,
      },
      role: "",
    });

    UserRepository._usersEntities.set(userId, entity);

    return entity;
  }

  public async validAuthentication() {
    const keycloak: Keycloak = UserRepository.KEYCLOAK;
    let varKeyloack;
    let varAuthenticated = false;
    let testingRole: string = "";
    let roleActive: string = "";
    let nameUser: string = "";
    try {
      const authenticated = await keycloak.init({
        onLoad: "login-required",
      });
      UserRepository.KEYCLOAK = keycloak;
      UserRepository.AUTHENTICATED = authenticated;
      varKeyloack = UserRepository.KEYCLOAK;
      varAuthenticated = UserRepository.AUTHENTICATED;

      /*
       * tokenParsed es la data desencriptada que viene de keycloak
       */
      const tokenParsed: any = keycloak?.tokenParsed;
      testingRole = this.cleanRoleList(tokenParsed.roles);
      // testingRole = tokenParsed.resource_access["pao-web"].roles;

      /*
       * Valida el rol activo antes de elegir que dashboard mostrar
       */
      roleActive = this._storage.getItem(UserRepository.ROLE_STORAGE_ACTIVE);

      if (testingRole.length > 1) {
        if (roleActive === "") {
          this._storage.setItem(UserRepository.ROLE_STORAGE_ACTIVE, "");
        }
      } else if (testingRole.length === 1) {
        this._storage.setItem(
          UserRepository.ROLE_STORAGE_ACTIVE,
          testingRole[0]
        );
        roleActive = testingRole[0];
      }

      /*
       * NAMESPACE utilizado para generar el id del usuario
       */
      const NAMESPACE: string = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
      const userGenerateV5 = uuidv5(
        tokenParsed?.preferred_username.toUpperCase(),
        NAMESPACE
      );

      this._storage.setItem(
        UserRepository.ROLE_STORAGE,
        tokenParsed.roles[0].toUpperCase()
      );
      this._storage.setItem(
        UserRepository.TOKEN_STORAGE,
        keycloak?.token as string
      );
      this._storage.setItem(
        UserRepository.REFRESH_TOKEN_STORAGE,
        keycloak?.refreshToken as string
      );

      this._storage.setItem(
        UserRepository.USERID_STORAGE,
        userGenerateV5 as string
      );
      this._storage.setItem(
        UserRepository.ROLE_STORAGE_TEST,
        tokenParsed.roles
      );
      localStorage.setItem("#!!TTDW05452q", testingRole);
      nameUser = tokenParsed.given_name.split(" ")[0].toLowerCase();
    } catch (error) {
      console.error(error);
    }
    return { varKeyloack, varAuthenticated, testingRole, roleActive, nameUser };
  }

  public  logoutUser() {
    const urlOrigin = window.location.origin;
    UserRepository.KEYCLOAK.logout({ redirectUri: urlOrigin });
  }
  
}
